import React from 'react'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from '../../contexts/i18n/use'

export const CancelTicketInfo = ({cancelticketcallback, closemodalcallback}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t}} = useTranslation();

  return (
    <Dialog 
      open={true} 
      classes={{paper: classes.modal}}
      >
      <DialogTitle>{ t('ticketpage.leavequeueconfirmation.title')}</DialogTitle>
      <DialogContent id="ticket-cancelticket-dialog-content-id">
        { t('ticketpage.leavequeueconfirmation.text')}
      </DialogContent>
      <DialogActions className={classes.buttonwrapper}>
      <Button className={[classes.cancelbutton, "dialogbutton"].join(' ')} id="ticket-cancelticket-recline-button-id" onClick={() => { closemodalcallback() }}>
        <Typography id="ticket-cancelticket-recline-button-text-id">
          { t('ticketpage.leavequeueconfirmation.cancel')}
        </Typography>
      </Button>
      <Button className={[classes.confirmbutton, "dialogbutton"].join(' ')} id="ticket-cancelticket-confirm-button-id" onClick={() => { cancelticketcallback() }}>
        <Typography id="ticket-cancelticket-confirm-button-text-id">
          { t('ticketpage.leavequeueconfirmation.confirm')}
        </Typography>
      </Button>
      </DialogActions>
    </Dialog>
  )
}

const useStyles = makeStyles({
  modal: theme => ({
    border: '1px solid '+ theme.palette.primary.main,
    alignItems: 'center'
  }),
  buttonwrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '80%'
  },
  confirmbutton: theme => ({
    backgroundColor: theme.palette.info.main,
    color: theme.palette.success.main,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.button_text.main
      }
    }
  }),
  cancelbutton: theme => ({
    backgroundColor: theme.palette.info.main,
    color: theme.palette.secondary.main,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.button_text.main
      }
    }
  })
})